import { render, staticRenderFns } from "./SubmissionSession.vue?vue&type=template&id=f4610b3a&scoped=true&"
import script from "./SubmissionSession.vue?vue&type=script&lang=js&"
export * from "./SubmissionSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4610b3a",
  null
  
)

export default component.exports